import { render, staticRenderFns } from "./WebinarForma.vue?vue&type=template&id=6bde924a&scoped=true&"
import script from "./WebinarForma.vue?vue&type=script&lang=js&"
export * from "./WebinarForma.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bde924a",
  null
  
)

export default component.exports